import React from 'react';
import { ToastProvider } from '@aptuno/aptuno-ui';
import { AptunoMuiThemeProvider } from '../styles/theme';

const Providers = ({ children }) => {
  return (
    <AptunoMuiThemeProvider>
      <ToastProvider variant={'top_right'}>{children}</ToastProvider>
    </AptunoMuiThemeProvider>
  );
};

export default Providers;
